import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  text: {
    padding: '8px 16px 16px'
  },
  divider: {
    marginBlock: '0px 20px'
  },
  empty: {
    marginTop: 32
  }
}))
